module.exports = __webpack_public_path__ + "static/media/left-arrow.2fa7256f.svg";